import React from 'react'
import Script from 'next/script'

import { useBusiness } from 'src/hooks/useBusiness'
import { useMarket } from 'src/hooks/useMarket'
import { useSession } from 'src/hooks/useSession'

export function HotjarUserAttributes() {
  const { id } = useSession()
  const { language, market } = useMarket()
  const { affiliate } = useBusiness()

  const scriptContent = `
    (function() {
      if (typeof window.hj === 'undefined') return;

      const userId = ${JSON.stringify(id)} || null;
      window.hj('identify', userId, {
        'Language': ${JSON.stringify(language)},
        'Market': ${JSON.stringify(market)},
        'Affiliate': ${JSON.stringify(affiliate)}
      });
    })();
  `

  return (
    <Script
      id="hotjar-user-attributes"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{ __html: scriptContent }}
    />
  )
}
